function StepDrawer({
    currentStep,
    totalSteps,
    onCancel,
    onContinue,
    disabled,
    onBack,
    title,
    children,
    showSkip = false
}) {
    return (
        <div className="step-drawer">
            <div className="navigation-buttons step-drawer-navigation">
                <h2>{title}</h2>
                <button className="cancel-button" onClick={onCancel}>
                    ×
                </button>
            </div>

            <div style={{
                flex: 1,
                overflow: 'auto',
                padding: '0 16px',
            }} className="step-drawer-children-container">
                {children}
            </div>
            <div className="form-footer-container">
                <div>
                    Step {currentStep} of {totalSteps}
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                    {(currentStep > 1) && (
                        <button
                            className="back-button"
                            onClick={onBack}
                        >
                            Back
                        </button>
                    )}
                    {(currentStep === 1) && (
                        <button
                            className="back-button"
                            onClick={onCancel}
                        >Cancel</button>
                    )}
                    <button
                        className="continue-button"
                        disabled={disabled}
                        onClick={() => onContinue()}
                    >
                        {`${
                            currentStep == totalSteps ?
                            'Submit' :
                            (showSkip ? 'Skip' : 'Continue')}`}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default StepDrawer;